// Confirmation modal that can handle one or two buttons
// https://www.figma.com/file/ZbEAVLEtBC4FmqZAklghVx/Candidate-Profiles?node-id=1190%3A895

import Button from "@/dashboard/core/components/Button";
import { FocusOn } from "react-focus-on";
import React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import theme from "@/styles/theme";

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  display: ${(props) => (props.$isVisible ? "flex" : "none")};
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  background: ${theme.colors.gray900};
  background-color: rgba(36, 36, 36, 0.5);
`;

const Container = styled.div`
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  box-sizing: border-box;
  width: 311px;
  padding: ${theme.spacing.unit * 2}px;
  background: ${theme.colors.white};
  border-radius: 8px;
  text-align: center;
`;

const StatusIndicatorContainer = styled.div`
  padding: ${theme.spacing.unit * 1}px 0;
`;

const Title = styled.div`
  padding: ${theme.spacing.unit * 1}px 0;

  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: ${theme.colors.gray900};
`;

const Subtitle = styled.div`
  padding: ${theme.spacing.unit * 1}px 0;
  white-space: pre-wrap;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${theme.colors.gray900};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  margin: ${theme.spacing.unit * 2}px 0;
`;

const StyledButton = styled(Button)`
  flex: 1 0;
  margin: 0 ${theme.spacing.unit * 1}px;
`;

const ConfirmModal = (props) => {
  const {
    isVisible,
    statusIndicator,
    title,
    subtitle,
    content,
    cancelButtonLabel,
    onCancel,
    confirmButtonLabel,
    onConfirm,
  } = props;

  return (
    <>
      {createPortal(
        <OverlayContainer $isVisible={isVisible}>
          <FocusOn enabled={isVisible} gapMode={"padding"}>
            <Container>
              {statusIndicator && (
                <StatusIndicatorContainer>
                  {statusIndicator}
                </StatusIndicatorContainer>
              )}
              {title && <Title>{title}</Title>}
              {subtitle && <Subtitle>{subtitle}</Subtitle>}
              {content && content}
              <ButtonContainer>
                {cancelButtonLabel && (
                  <StyledButton isGhost isSmall onClick={onCancel}>
                    {cancelButtonLabel}
                  </StyledButton>
                )}
                <StyledButton isSmall onClick={onConfirm}>
                  {confirmButtonLabel}
                </StyledButton>
              </ButtonContainer>
            </Container>
          </FocusOn>
        </OverlayContainer>,
        document.body
      )}
    </>
  );
};

export default ConfirmModal;
